import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import React, { useState } from "react";

import * as S from "../../constants/StringConstants";
import "./LauncherModalV2.scss";

interface ILauncherModalV2Props {
  launcher: React.ReactNode;
  onConfirm: () => void;
  title?: string;
  body?: string;
}

const LauncherModalV2: React.FC<ILauncherModalV2Props> = ({ launcher, onConfirm, title }) => {
  const [open, setOpen] = useState(false);

  const handleCancel = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleConfirm = () => {
    onConfirm();
    setOpen(false);
  };

  return (
    <>
      <div onClick={handleOpen}>{launcher}</div>
      <Dialog open={open} PaperProps={{ style: { width: "64rem", height: "auto", padding: "1rem 1rem" } }}>
        <DialogTitle className="launcher-modal-v2__title">{title}</DialogTitle>
        <DialogContent />
        <DialogActions>
          <button onClick={handleCancel} className="button-v2 button-v2__secondary">
            {S.DOC_DELETE_NO_BUTTON}
          </button>
          <button onClick={handleConfirm} className="button-v2 button-v2__primary" autoFocus>
            {S.DOC_DELETE_YES_BUTTON}
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LauncherModalV2;
